const isSelectorValid = (selector) => {
  try {
    document.createDocumentFragment().querySelector(selector);
  } catch {
    return false;
  }

  return true;
};

const scrollToAnchor = (anchorSrc) => {
  const anchor = anchorSrc || window.location.hash;

  if (isSelectorValid(anchor)) {
    const element = anchor && document.querySelector(anchor);

    if (element) {
      window.scrollTo({
        top: element.offsetTop,
        behavior: 'smooth',
      });
    }
  }
};

export default scrollToAnchor;
